import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useDataFetch, { DataFetchOptionsType } from "../../hooks/useDataFetch";
import { getAssessmentDetails, getCandidatesData } from "./services";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import classNames from "classnames";
import RenderHeader from "./partials/renderHeader";
import ReportGrid from "./components/ReportGrid";

const AssessmentReport = () => {
  const { assessmentId } = useParams();
  //   const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //     error: { msg: "API Failed" },
  //   });
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  const { loading, data, error } = useDataFetch(
    fetchAssessmentDetails,
    fetchOptions
  );

  async function fetchAssessmentDetails() {
    let assessmentDetails: any = await Promise.all([
      getAssessmentDetails(assessmentId),
      getCandidatesData(assessmentId),
    ]);

    return {
      headerData: { ...assessmentDetails[0] },
      gridData: [...assessmentDetails[1]],
    };
  }

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  return (
    <div className={classNames("report-container")}>
      <div className="card row w-full h-full overflow-y-scroll">
        <div className="col-12 h-[30%] min-h-fit">
          {<RenderHeader data={data.headerData} assessmentId={assessmentId} />}
        </div>
        <div className="col-12 h-[70%] row">
          {
            <ReportGrid
              gridDataAPI={data.gridData}
              assessmentId={assessmentId}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default AssessmentReport;
